export default __webpack_public_path__ + "static/media/Pickpocket's Leggings of the Fifth Stage.2a3cb96d.jpg";